function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.81067 11.1213V13.5C8.81067 14.3284 9.48224 15 10.3107 15H12.6894L11.1894 13.5H10.3107V12.6213L8.81067 11.1213ZM13.3107 11.3787V5.5H10.3107V8.37868L8.81067 6.87868V5.5C8.81067 4.67157 9.48224 4 10.3107 4H13.3107C14.1391 4 14.8107 4.67157 14.8107 5.5V12.8787L13.3107 11.3787ZM13.9394 16.25H8.81067C8.12031 16.25 7.56067 15.6904 7.56067 15V12C7.56067 11.5858 7.22488 11.25 6.81067 11.25C6.39646 11.25 6.06067 11.5858 6.06067 12V15C6.06067 16.5188 7.29189 17.75 8.81067 17.75H11.0607V21.5C11.0607 21.7761 11.2845 22 11.5607 22H12.0607C12.3368 22 12.5607 21.7761 12.5607 21.5V17.75H14.8107C15.006 17.75 15.1965 17.7296 15.3803 17.6909L13.9394 16.25ZM17.5016 15.5696L16.0607 14.1287V12C16.0607 11.5858 16.3965 11.25 16.8107 11.25C17.2249 11.25 17.5607 11.5858 17.5607 12V15C17.5607 15.1953 17.5403 15.3858 17.5016 15.5696Z",
  fill: "#061220"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 4.06067,
  y: 3,
  width: 24,
  height: 1.5,
  rx: 0.75,
  transform: "rotate(45 4.06067 3)",
  fill: "#061220"
});

function SvgMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.265765e1.svg";
export { ForwardRef as ReactComponent };